import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ActionsRender } from './components/actions-render';
import { ActionsRenderProps, WithAdditionalType } from './components/actions-render/types';
import { BaseTable, BaseTableProps } from './components/base-table';
import { ACTION_KEY } from './constants';
import { ColumnDefinitionInterface } from './types/column-interface';
import { resolveRowId } from './utils';
export type TableProps<T, K> = Omit<BaseTableProps<T>, 'renderMobileRow' | 'renderTabletRow'> & Partial<Omit<ActionsRenderProps<T, K>, 'instance'>> & {
  /**
   * Replaces the labelled column stack inside the mobile card with a hand-composed layout. The
   * actions menu of the row is passed in so the card can place it itself.
   */
  renderMobileRow?: (row: T, actions: React.ReactNode) => React.ReactNode;
  /** Optional tablet layout; otherwise preserves the mobile renderer or default mobile cards. */
  renderTabletRow?: (row: T, actions: React.ReactNode) => React.ReactNode;
};
export function Table(t0) {
  const $ = _c(35);
  let actions;
  let actionsOrder;
  let actionsTitle;
  let caption;
  let columns;
  let getRowId;
  let renderMobileRow;
  let renderTabletRow;
  let restProps;
  let testAttributePostfix;
  if ($[0] !== t0) {
    ({
      testAttributePostfix,
      getRowId,
      actions,
      caption,
      columns,
      actionsOrder,
      actionsTitle,
      renderMobileRow,
      renderTabletRow,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = actions;
    $[2] = actionsOrder;
    $[3] = actionsTitle;
    $[4] = caption;
    $[5] = columns;
    $[6] = getRowId;
    $[7] = renderMobileRow;
    $[8] = renderTabletRow;
    $[9] = restProps;
    $[10] = testAttributePostfix;
  } else {
    actions = $[1];
    actionsOrder = $[2];
    actionsTitle = $[3];
    caption = $[4];
    columns = $[5];
    getRowId = $[6];
    renderMobileRow = $[7];
    renderTabletRow = $[8];
    restProps = $[9];
    testAttributePostfix = $[10];
  }
  let t1;
  if ($[11] !== actions || $[12] !== actionsOrder || $[13] !== actionsTitle || $[14] !== caption || $[15] !== getRowId || $[16] !== testAttributePostfix) {
    t1 = instance => actions && Object.keys(actions).length > 0 ? <ActionsRender caption={caption} actionsTitle={actionsTitle} actions={actions} instance={instance as WithAdditionalType<T, K>} rowId={resolveRowId({
      row: instance,
      getRowId
    })} testAttributePostfix={testAttributePostfix} actionsOrder={actionsOrder} /> : null;
    $[11] = actions;
    $[12] = actionsOrder;
    $[13] = actionsTitle;
    $[14] = caption;
    $[15] = getRowId;
    $[16] = testAttributePostfix;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  const renderActions = t1;
  let t2;
  if ($[18] !== actions || $[19] !== columns || $[20] !== renderActions) {
    t2 = actions && Object.keys(actions).length > 0 ? [...columns, {
      key: ACTION_KEY,
      header: "",
      className: "!w-18",
      onRender: instance_0 => renderActions(instance_0)
    }] : columns;
    $[18] = actions;
    $[19] = columns;
    $[20] = renderActions;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  const columnsWithActions = t2;
  let t3;
  if ($[22] !== renderActions || $[23] !== renderMobileRow) {
    t3 = renderMobileRow ? row => renderMobileRow(row, renderActions(row)) : undefined;
    $[22] = renderActions;
    $[23] = renderMobileRow;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  let t4;
  if ($[25] !== renderActions || $[26] !== renderTabletRow) {
    t4 = renderTabletRow ? row_0 => renderTabletRow(row_0, renderActions(row_0)) : undefined;
    $[25] = renderActions;
    $[26] = renderTabletRow;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  let t5;
  if ($[28] !== columnsWithActions || $[29] !== getRowId || $[30] !== restProps || $[31] !== t3 || $[32] !== t4 || $[33] !== testAttributePostfix) {
    t5 = <BaseTable getRowId={getRowId} columns={columnsWithActions} testAttributePostfix={testAttributePostfix} renderMobileRow={t3} renderTabletRow={t4} {...restProps} />;
    $[28] = columnsWithActions;
    $[29] = getRowId;
    $[30] = restProps;
    $[31] = t3;
    $[32] = t4;
    $[33] = testAttributePostfix;
    $[34] = t5;
  } else {
    t5 = $[34];
  }
  return t5;
}